import React from 'react';
import MDKPIApproval from './HM_KPI_Approval';
import '../../../CommonCSS/SocietyCSS.css'

const HM_KPI_ApprApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>HM/Principal Monthly KPI Approval</h5>
          </div>
        </div>
        <MDKPIApproval/>
      </div>
    </div >
  );
};

export default HM_KPI_ApprApp;
